export default __webpack_public_path__ + "static/media/WinterSale_CampingTents_900x525.d288bf0d.jpg";